import makeCrud from '@/store/site/localization/crud'

// Otomasyon workflow'ları — ortak CRUD + canvas paleti için katalog.
const base = makeCrud('ecommerce_automation')

export default {
    ...base,
    actions: {
        ...base.actions,

        // Trigger/koşul/aksiyon kataloğu + sipariş durumları (canvas paleti).
        async catalog() {
            const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_automation_catalog'))
            return res.data.data
        },
    },
}
